// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1a6B-","content":"RecentSearches_content__1axFJ"};